// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1DF7L","file":"styles_file__2N0-k"};